export function forceIdToArray(id) {
  if (Array.isArray(id) && id.length > 0) {
    return id.map(_id => Number.parseInt(_id, 10)).filter(_id => !Number.isNaN(_id));
  }
  if (id && !Number.isNaN(Number.parseInt(id, 10))) {
    return [id];
  }
  return undefined;
}
